/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * TODO
 */
export type ChangeOfTenancyType =
  (typeof ChangeOfTenancyType)[keyof typeof ChangeOfTenancyType]

export const ChangeOfTenancyType = {
  ChangeOfTenancyMoveOut: "ChangeOfTenancyMoveOut",
  ChangeOfTenancyMoveIn: "ChangeOfTenancyMoveIn",
} as const
